import axios from 'axios'

const apiBase = process.env.VUE_APP_API_URL || ''
const base = `${apiBase}/api/domains`

const enc = (domain) => encodeURIComponent(domain)

export const domainsApi = {
  list: (params) => axios.get(base, { params }).then(r => r.data),
  getDns: (domain) => axios.get(`${base}/${enc(domain)}/dns`).then(r => r.data),
  setDns: (domain, records) => axios.put(`${base}/${enc(domain)}/dns`, { records }).then(r => r.data),
}

export default domainsApi
